<template>
    <v-dialog
        v-model="show"
        max-width="250"
    >
        <v-card>
            <v-toolbar
                color="primary"
                dark
                flat
            >
                <v-toolbar-title>
                    Share Offer
                </v-toolbar-title>
            </v-toolbar>

            <v-card-actions class="pa-10 justify-space-around">
                <ShareNetwork
                    network="twitter"
                    :url="sharedUrl"
                    :title="sharedText"
                    twitter-user="KaoshiNetwork"
                    class="v-btn v-btn--contained v-btn--fab v-btn--round theme--light v-size--small primary"
                >
                    <v-icon color="white">
                        mdi-twitter
                    </v-icon>
                </ShareNetwork>

                <ShareNetwork
                    network="facebook"
                    :url="sharedUrl"
                    :title="sharedText"
                    :quote="sharedText"
                    hashtags="KaoshiNetwork"
                    class="v-btn v-btn--contained v-btn--fab v-btn--round theme--light v-size--small primary"
                >
                    <v-icon color="white">
                        mdi-facebook
                    </v-icon>
                </ShareNetwork>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: {
            value: {
                type: Boolean,
                default: false,
            },
            order: {
                type: Object,
                required: true,
            },
        },
        data: () => ({
            sharedText: 'OMG! did you see this amazing international money transfer offer on Kaoshi Network?',
        }),
        computed: {
            show: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit('input', val);
                },
            },
            sharedUrl() {
                return `${process.env.MIX_APP_URL}/offers/${this.order.id}`;
            },
        },
    };
</script>
